import { useEffect } from "react";

export function NotFoundPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Page not found · Memoru";
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <>
      <link rel="stylesheet" href="/404.css" precedence="default" />
<div className="nf-page">
  <header><a className="nf-brand" href="/"><svg className="nf-mark" viewBox="0 0 64 64" aria-hidden="true" focusable="false"><path className="nf-mark-tile" d="M32 1 C56 1 63 8 63 32 C63 56 56 63 32 63 C8 63 1 56 1 32 C1 8 8 1 32 1 Z"/><rect className="nf-mark-ink" x="13" y="22" width="28" height="29" rx="6"/><circle className="nf-mark-dot" cx="41" cy="23" r="11"/></svg><span className="nf-wordmark">memoru<span className="nf-wordmark-dot">.</span></span></a></header>
  <main className="nf-main">
    <section className="nf-content" aria-labelledby="not-found-title">
      <div className="nf-art" aria-hidden="true">
        <div className="nf-orbit"></div>
        <div className="nf-note"><span className="nf-line"></span><span className="nf-line"></span><span className="nf-line"></span></div>
        <svg className="nf-search" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></svg>
      </div>
      <p className="nf-code">404 · Page not found</p>
      <h1 className="nf-title" id="not-found-title">This page is missing.</h1>
      <p className="nf-description">The link may have changed, or the page no longer exists. Let’s get you back to your meetings.</p>
      <a className="nf-button" href="/meetings"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="m12 19-7-7 7-7M5 12h14"/></svg>Back to meetings</a>
      <p className="nf-hint">If you followed a shared link, check it with the sender.</p>
    </section>
  </main>
  <footer className="nf-footer">Memoru · Make every conversation count.</footer>
</div>
    </>
  );
}
